<template>
  <div class="letters">
    <div class="top">
      <button @click="$router.go(-1)">
        <img src="../assets/back-arrow.png" alt="back" width="24">
      </button>
      <help-button />
    </div>
      <transition name="fade">
        <div class="content letter" key="letter" v-if="!transcript">
            <div class="pages">
          <!-- <h1 class="logo">{{ exhibit.name }} - {{ letters[letter].title }}</h1> -->
              <img v-for="(image,i) in letters[letter].images" :src="image.url" :key="i">
            </div>
        </div>
        <div class="content" key="transcript" v-if="transcript">
          <h1 class="logo">{{ exhibit.name }} - {{ letters[letter].title }}</h1>
            <div class="textbox" v-html="letters[letter].transcript"></div>
        </div>
      </transition>
      <div class="controls" v-if="!transcript">
        <button
          class="reverse"
          @click="transcript = true">
          Show Excerpt
        </button>
      </div>
      <div class="controls" v-if="transcript">
        <button
          class="reverse"
          @click="transcript = false">
          Show Letter
        </button>
      </div>
      <div class="controls">
        <button
          class="reverse"
          v-if="letter > 0"
          @click="$router.replace({ name: 'letters', params: { exhibitid: exhibitid, letter: (letter - 1) } })">
          Previous
        </button>
        <button
          class="reverse"
          v-if="letter+1 < letters.length"
          @click="$router.replace({ name: 'letters', params: { exhibitid: exhibitid, letter: (letter + 1) } })">
          Next
        </button>
      </div>
  </div>
</template>

<script>
// import ExampleImage from '../assets/letters/example.jpg'
// import TinySlider from 'vue-tiny-slider'
// import 'tiny-slider/dist/tiny-slider.css'

export default {
  name: 'Letters',
  components: {
    //'tiny-slider': TinySlider
  },
  props: {
    exhibitslug: {
      type:String,
      default:''
    },
    letter: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      transcript: false,
      show: true
    }
  },
  computed: {
    exhibits () {
      return this.$store.state.exhibits
    },
    exhibitdata () {
      return this.$store.state.exhibit_data[this.exhibitid]
    },
    exhibit () {
      return this.exhibits[this.exhibitid]
    },
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    },
    name () {
      return this.exhibitid ? this.exhibit.name : ''
    },
    letters () {
      return this.exhibitdata.letters
      // return [
      //   { title: 'Letter 1', file: ExampleImage, transcript: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam a mauris sit amet purus eg Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam a mauris sit amet purus eg.</p>' },
      //   { title: 'Letter 2', file: ExampleImage, transcript: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam a mauris sit amet purus eg Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam a mauris sit amet purus eg.</p>' }
      // ]
    }
  }
}
</script>

<style lang="scss" scoped>
// .fade-enter-active, .fade-leave-active {
//   transition: opacity 5s;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }
.letters {
  color: #000;
  height: 100%;
  overflow: hidden;
  background-color: black;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
}
.top {
  padding: 10px;

  display: flex;
  justify-content: space-between;
}
.content {
  &.letter {
    background-color: transparent;
    padding: 0;
    color: white;
  }
  .pages img {
    display: block;
    margin: 0 auto;
  }
  color: #000;
  overflow:auto;
  background-color: white;
  padding: 20px;
  margin: 30px;
  margin-bottom: 10px;
  margin-top: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .logo {
    flex: 0;
  }
  p, div {
    flex: 1;
  }
}
div.controls {
  padding-bottom: 10px;
  flex: 0;
}
</style>
